import NavigationBar from "../navigation/nav-bar/navigationBar";
import FooterComponent from "../navigation/footer/footerComponent";
import MissionBodyComponent from "./missionBodyComponent";


export default function Mission(props) {

    return (
        <div>
            <NavigationBar />
            <MissionBodyComponent />
            <FooterComponent />
        </div>
    )
}